const KEY_PREFIX = 'ti:membership-renewal-opt-in:2027:shown:';

export function markerKey(userId) {
    return `${KEY_PREFIX}${userId}`;
}

export function hasMarker(userId) {
    if (!userId) {
        return true;
    }

    try {
        return window.localStorage.getItem(markerKey(userId)) !== null;
    } catch (e) {
        console.warn('Renewal opt-in marker could not be read; suppressing the prompt.');
        return true;
    }
}

export function writeMarker(userId) {
    if (!userId) {
        return false;
    }

    try {
        window.localStorage.setItem(markerKey(userId), new Date().toISOString());
        return true;
    } catch (e) {
        console.warn('Renewal opt-in marker could not be written; suppressing the prompt.');
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/services/renewal-opt-in-marker.js